<template>
  <div>
    <div class="ou-donation-form">
      <div class="membership">
        <p>
          <a
            href="https://www.ou.org/membership/?utm_source=mainOUform&amp;utm_medium=link&amp;utm_campaign=membership"
            >Click here</a
          >
          to Become an OU Member or renew your OU Membership
        </p>
      </div>
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="I would like to give:">
            <div>
              <p><em>Please select your tax-deductible gift amount below</em></p>
              <AmountSelector />
              <ErrorLabel field="amount" />
            </div>

            <!-- <div class="donate__note" v-if="form.amount && form.amount < 72">
              <label
                >When you donate at the $108 or more, you'll receive the OU pocket calendar
                diary, an OU membership discount card and a subscription to Jewish Action
                magazine.</label
              >
            </div> -->
            <br />
            <OuGivingPaymentOptions addMonthly />
            <br />
            <InHonorOf />
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="2. Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
            </FormRow>
            <DonorAddress />
            <FormRow inline>
            <FormCol field="phone" />
          </FormRow>
              <Consent privacy="https://www.ou.org/privacy-policy/"/>
          </FormSection>
          <FormSection title="3. Payment Information" last>
            <FormCol field="card" :showLabel="false" />
          </FormSection>
          <FormRow>
            <NewsletterSubscribe
              text="Sign me up for the OU's weekly Shabbat Shalom newsletter"
            />
          </FormRow>
          <br />
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup() {
    const { form, submit, setValue } = usePaymentForm();
    // setValue('callback', process.env.NODE_ENV != 'production' ? 'https://www.ou.org/wp-json/api/membership/newsletter' : 'https://www.ou.org/wp-json/api/membership/newsletter')

    return {
      form,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

::v-deep .ou-donation-form {
  line-height: 1.4;
  hr {
    border-bottom: 2px dashed #ddd;
  }
  h2 {
    color: #3399f3;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 15px;
  }

  input[type="email"],
  input[type="number"],
  input[type="password"],
  input[type="tel"],
  input[type="text"],
  textarea,
  select {
    font-size: 14px;
  }
  input[type="tel"] {
    height: 42px;
  }
}
::v-deep .frequency {
  display: flex;
  justify-content: space-between;

  .styled-radio-container--ou-donation.styled-radio-contain {
    margin: 0px 0px 0px auto;
    justify-content: flex-end;

    .radio-part {
      margin-bottom: 0px;
    }
    input[type="radio"] {
      position: relative;
    }
  }
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
input[type="checkbox"] {
  margin-right: 5px;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="12"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "college student special";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}

// ::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:not(:checked) + label[data-amount="100"] {
//   background: #eee7fd;
// }

::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:not(:checked) + label {
  background: #e5e8e9;
  color: #222;
}
::v-deep .styled-radio--ou-donation.styled-radio input[type="radio"]:checked + label {
  background: #3399f3;
  color: white;
}
::v-deep .styled-radio--ou-donation.styled-radio .amount_other__wrapper {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
}
::v-deep .ou-donation-form .ou-donation-btn {
  background: #3399f3;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}
::v-deep .thank-you-container .ou-donation-btn {
  background: #3399f3;
  color: white;
  font-size: 20px;
  height: 50px;
  border-color: white;
}

.donate__note {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid rgb(214, 233, 198);
  border-radius: 4px;
  color: rgb(60, 118, 61);
  background-color: rgb(223, 240, 216);
}

.membership {
  font-size: 14px;
  margin: 15px 0;
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f;
  padding: 11px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 0px solid #000000;
  p {
    margin: 0;
  }
  a {
    color: #2403ee;
    font-weight: bold;
  }
}
</style>
